export default __webpack_public_path__ + "static/sponsor@2x-37489fadc77f1d23004bbcf3f1d31eb5.png";